import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import { Trans } from "@lingui/react/macro";
import ModelTrainingIcon from "@mui/icons-material/ModelTraining";
import theme from "../../theme.tsx";
import type { RootState } from "../../store/types.tsx";
import { conversationActions } from "../../store/conversation.tsx";

interface LLMModel {
  name: string;
  label: string;
}

interface SelectLLMModelProps {
  availableModels: LLMModel[];
}

const SelectLLMModel: React.FC<SelectLLMModelProps> = ({ availableModels }) => {
  const dispatch = useDispatch();

  const selectedOption = useSelector(
    (state: RootState) => state.conversationState.selectedModel,
  );

  const handleOptionChange = (event: SelectChangeEvent<string>) => {
    const model = event.target.value as string;
    dispatch(conversationActions.setSelectedModel(model));
  };

  return (
    <Box>
      <Typography
        variant="body2"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(1),
          marginTop: theme.spacing(1),
          justifyContent: "flex-start",
          fontSize: "1rem !important",
        }}
      >
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "20px",
            height: "20px",
          }}
        >
          <ModelTrainingIcon />
        </Box>
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "center",
          }}
        >
          <Trans>Choose a model</Trans>
        </Box>
      </Typography>
      <Select
        value={selectedOption || ""}
        onChange={handleOptionChange}
        displayEmpty
        sx={{
          marginTop: theme.spacing(0.5),
          width: "100%",
          border: "none",
          boxShadow: "none",
          "&:focus": {
            border: "none",
            boxShadow: "none",
          },
        }}
      >
        {availableModels.map((model) => (
          <MenuItem key={model.name} value={model.name}>
            {model.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default SelectLLMModel;
